import React, {
  useCallback, useEffect, useState, memo,
} from 'react';
import Bb from 'bluebird';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect, useDispatch} from 'react-redux';
import {ActionHideCookiesNotification} from '../../store/actions/actions-pages';
import './CookiesNotification.less';
import {ROUTES} from '../../configs/routes';

function CookiesNotification({hideCookiesNotification, skipDelay}) {
  const [show, changeShow] = useState(false);

  const dispatch = useDispatch();

  const init = useCallback(() => {
    if (!hideCookiesNotification) {
      if (skipDelay) {
        changeShow(true);
        return;
      }
      Bb.delay(10000).then(() => changeShow(true));
    }
  }, [hideCookiesNotification, skipDelay]);

  const onHideCookiesNotification = useCallback(() => {
    dispatch(ActionHideCookiesNotification());
  }, []);

  useEffect(() => {
    init();
  }, []);

  if (!show || hideCookiesNotification) {
    return null;
  }

  return (
    <div className="cooki_panel">
      <div className="cooki_content">
        <div className="cooki_txt">
          Этот веб-сайт использует файлы cookie для повышения удобства в работе. Переход по ссылке на данный веб-сайт
          или переходы по страницам на самом веб-сайте подразумевают согласие со сбором данных по средствам файлов
          cookie. Узнать больше об использование файлов cookie и о изменении своих настроек можно, перейдя по
          &nbsp;
          <Link to={ROUTES.PROCESSING_POLICY.route} className="link">ссылке</Link>
        </div>
        <div className="cooki_btn">
          <button type="button" className="btn btn-base" onClick={onHideCookiesNotification}>Принять</button>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({rPages}) {
  return {
    hideCookiesNotification: rPages.hideCookiesNotification,
  };
}

CookiesNotification.defaultProps = {
  hideCookiesNotification: false,
  skipDelay: false,
};

CookiesNotification.propTypes = {
  hideCookiesNotification: PropTypes.bool,
  skipDelay: PropTypes.bool,
};

export default connect(mapStateToProps, null)(memo(CookiesNotification));
